var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-item",class:{
    glassy: _vm.glassy,
    transparent: _vm.transparent,
    np: _vm.np,
    colored: _vm.colored,
  },style:(_vm.cssProps),attrs:{"slot":"grid-item"},slot:"grid-item"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }